export const colors = ['#037cd8', '#03c482', '#db9818', '#dc3d54', '#6852b4', '#FFF574', '#98FF61', '#008A00', '#FF2929', '#FFF100']

export default function formatIndianNumber(original) {
    const originalNumber = typeof original === 'string' ? parseFloat(original) : original

    if (!isFinite(originalNumber)) {
        return original
    }

    return formatAfterCleanup(originalNumber)
}

function formatAfterCleanup(originalNumber) {
    let originalMag
    let negative

    if (originalNumber < 0) {
        originalMag = -1 * originalNumber
        negative = true
    } else {
        originalMag = originalNumber
        negative = false
    }

    const integerPart = Math.floor(originalMag)

    const arr = String(integerPart).split('').reverse()
    const result = []

    let c = 0
    for (let i = 0; i < arr.length; i++) {
        result.push(arr[i])
        c++
        if ((c === 3 || c === 5 || c === 7) && (i < arr.length - 1)) {
            result.push(',')
        }
        if (c === 7) {
            c = 0
        }
    }

    if (negative) {
        result.push('-')
    }

    return result.reverse().join('')
}